import * as React from 'react';
import { getFormattedStabilityMetrics } from '@/components/selectedAppStoreBuild/StabilityMetrics';
import { StabilityInfo } from '@/types';
import Text from 'antd/lib/typography/Text';
import { antGrey, titleStyle } from '@/components/styles/globalStyles';
import Space from 'antd/lib/space';
import Divider from 'antd/lib/divider';

export interface StabilityMetricsInlinePercentagesProps {
    stabilityInfo: StabilityInfo;
}

export const StabilityMetricsInlinePercentages: React.FC<StabilityMetricsInlinePercentagesProps> = ({
    stabilityInfo,
}) => {
    const { userStability, sessionStability, sessionAdoption } = getFormattedStabilityMetrics(stabilityInfo);
    return (
        <Space align="center" split={<Divider type="vertical" style={{ backgroundColor: antGrey.grey5 }} />}>
            <MetricTitleAndValue title="User stability" value={userStability} />
            <MetricTitleAndValue title="Session stability" value={sessionStability} />
            <MetricTitleAndValue title="Adoption rate (sessions)" value={sessionAdoption} />
        </Space>
    );
};

const MetricTitleAndValue: React.FC<{ title: string; value: string }> = ({ title, value }) => {
    const stabilityValueStyle: React.CSSProperties = {
        fontSize: 20,
        fontWeight: 600,
        color: antGrey.grey8,
        marginTop: 24,
    };

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'baseline',
                gap: 8,
            }}
        >
            <Text
                style={{
                    ...titleStyle,
                    color: antGrey.grey7,
                    fontSize: 12,
                    lineHeight: 1.6,
                }}
            >
                {title}
            </Text>

            <Text style={{ ...stabilityValueStyle, fontSize: 12, marginTop: 0 }}>{value}</Text>
        </div>
    );
};
